import { Heading, Section } from "../../Bits";

export default function HeadingBlock({ data }) {
  const { overline, title, subtitle } = data || {};
  return (
    <Section>
      <Heading overline={overline} title={title} subtitle={subtitle} />
    </Section>
  );
}
